export interface BehaviorItem {
  name: string;
  body: string;
  courses?: string;
}

export function BehaviorList({ items }: { items: readonly BehaviorItem[] }) {
  return (
    <div className="grid gap-5 md:grid-cols-2">
      {items.map((item) => (
        <div
          key={item.name}
          className="rounded-2xl border border-border/60 bg-background p-6 transition-colors hover:border-primary/30"
        >
          <h4 className="font-display text-lg text-ink">{item.name}</h4>
          <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{item.body}</p>
          {item.courses && (
            <p className="mt-3 text-xs uppercase tracking-wider text-primary">
              Courses:{" "}
              <span className="font-normal normal-case tracking-normal text-muted-foreground">
                {item.courses}
              </span>
            </p>
          )}
        </div>
      ))}
    </div>
  );
}
